/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_LiveInputs */

const en_us2_workout_quick_live = /** @type {(inputs: Workout_Quick_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workout is running on this device. Finish it before logging another one.`)
};

const pt_br2_workout_quick_live = /** @type {(inputs: Workout_Quick_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há um treino em andamento neste aparelho. Termine-o antes de registrar outro.`)
};

const es_419_workout_quick_live = /** @type {(inputs: Workout_Quick_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hay un entrenamiento en curso en este dispositivo. Termínalo antes de registrar otro.`)
};

const pt_pt2_workout_quick_live = /** @type {(inputs: Workout_Quick_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há um treino a decorrer neste dispositivo. Termina-o antes de registar outro.`)
};

const fr_fr2_workout_quick_live = /** @type {(inputs: Workout_Quick_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une séance est en cours sur cet appareil. Termine-la avant d'en noter une autre.`)
};

const de_de2_workout_quick_live = /** @type {(inputs: Workout_Quick_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf diesem Gerät läuft ein Training. Beende es, bevor du ein anderes einträgst.`)
};

const it_it2_workout_quick_live = /** @type {(inputs: Workout_Quick_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'è un allenamento in corso su questo dispositivo. Finiscilo prima di registrarne un altro.`)
};

/**
* | output |
* | --- |
* | "A workout is running on this device. Finish it before logging another one." |
*
* @param {Workout_Quick_LiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_live = /** @type {((inputs?: Workout_Quick_LiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_LiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_live(inputs)
	if (locale === "es-419") return es_419_workout_quick_live(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_live(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_live(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_live(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_live(inputs)
	return en_us2_workout_quick_live(inputs)
});
export { workout_quick_live as "workout-quick.live" }